export default __webpack_public_path__ + "static/media/npm-g.9e7b17f3.png";